// ------------------------------------------------------------------------
// -- JS DROPDOWNS
// ------------------------------------------------------------------------

var dropdowns = document.querySelectorAll('.dropdown');
for (var i = 0; i < dropdowns.length; i++) {
    dropdowns[i].querySelector('.dropdown__menu').classList.add('dropdown__menu--hidden');
    dropdowns[i].addEventListener('mouseover', toggleDropdown);
    dropdowns[i].addEventListener('mouseout', toggleDropdown);
   // dropdowns[i].addEventListener('click', toggleDropdown);
    dropdowns[i].addEventListener("keyup", toggleDropdownKey);
}

function toggleDropdown() {
    var btn = this.querySelector('.dropdown__toggle');
    var menu = this.querySelector('.dropdown__menu');
    if (btn.getAttribute('aria-expanded') === 'true') {
        btn.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-hidden', 'true');
        menu.classList.add('dropdown__menu--hidden');
    } else {
        btn.setAttribute('aria-expanded', 'true');
        menu.setAttribute('aria-hidden', 'false');
        menu.classList.remove('dropdown__menu--hidden');
    }
}

function toggleDropdownKey(e) {
    var btn = this.querySelector('.dropdown__toggle');
    var menu = this.querySelector('.dropdown__menu');
    if (e.keyCode == "27") {
        if (btn.getAttribute('aria-expanded') === 'true') {
            btn.setAttribute('aria-expanded', 'false');
            menu.setAttribute('aria-hidden', 'true');
            menu.classList.add('dropdown__menu--hidden');
            btn.focus();
        }
    }
    if ((e.keyCode == "13") || (e.keyCode == "32")) {
        if (btn.getAttribute('aria-expanded') === 'false') {
            btn.setAttribute('aria-expanded', 'true');
            menu.setAttribute('aria-hidden', 'false');
            menu.classList.remove('dropdown__menu--hidden');
        } else {
            btn.setAttribute('aria-expanded', 'false');
            menu.setAttribute('aria-hidden', 'true');
            menu.classList.add('dropdown__menu--hidden');
            btn.focus();
        }
    }
}